<template>
  <div class="Banner">
    <div class="PageGutter">
      <slot name="overlay"></slot>

      <div class="PageHeader">
        <slot name="header"></slot>

        <div class="PageCaption">
          <slot name="caption"></slot>
        </div>
      </div>

      <div class="Tabs">
        <slot name="tabs"></slot>
      </div>
    </div>

    <slot name="controls"></slot>

    <div class="Content">
      <Overlay :opacity="0.6"></Overlay>

      <div class="container container--wide">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import Overlay from '@/legacy/components/widgets/Overlay';

  export default {
    components: {
      Overlay
    },
  };
</script>

<style lang="scss">
  .Banner {
    display: flex;
    flex-direction: column;
    padding-bottom: 0 !important;
    width: 100%;

    .PageGutter {
      width: 100%;
      background-position: 0 -300px;
      background-repeat: no-repeat;
      background-size: cover;
      border-bottom: $w3s-border-region;
      box-shadow: inset 0 -180px 200px shade($w3s-black, 60);
      padding-bottom: 150px;
      position: relative;
    }

    .PageHeader {
      width: 100%;
      position: relative;
      z-index: fetch(z-index atop);
    }

    .W3S-loader {
      margin: 50px auto;
    }

    &-controls {
      display: flex;
      position: absolute;
      right: 15px;
      top: -40px;

      a.Button,
      button,
      select {
        height: 62px;
        width: auto;
        margin-left: 10px;
      }
    }
  }

  .Tabs {
    bottom: -2px;
    display: flex;
    flex-direction: row;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    max-width: map-fetch($config, container wide);
    z-index: fetch(z-index atop);
  }

  .Tab {
    border-bottom: 2px solid transparent;
    color: shade($w3s-white, 90);
    padding: 8px 28px;
    font-size: 1.75rem;

    &:hover {
      color: fetch(colour hover);
      border-bottom: fetch(border hover);
    }
  }

  .Content {
    width: 100%;
    background-image: asset('background/content.png');
  }
</style>